module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "index-wrap"
  }, [_c('transition', {
    attrs: {
      "name": "router",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "navitem",
    on: {
      "click": _vm.getindex
    }
  }, [_c('div', [_c('svg', {
    staticClass: "icon",
    class: {
      "active": _vm.isindex
    },
    staticStyle: {
      "transform": "scale(1.1)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shouye"
    }
  })])]), _c('div', [_vm._v("首页          ")])]), _c('div', {
    staticClass: "navitem",
    on: {
      "click": _vm.getfood
    }
  }, [_c('div', [_c('svg', {
    staticClass: "icon",
    class: {
      "active": _vm.isfood
    },
    staticStyle: {
      "transform": "scale(1.2)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-caidan"
    }
  })])]), _c('div', [_vm._v("菜单")])]), _c('div', {
    staticClass: "navitem",
    on: {
      "click": _vm.getorder
    }
  }, [_c('div', [_c('svg', {
    staticClass: "icon",
    class: {
      "active": _vm.isorder
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-icon-test"
    }
  })])]), _c('div', [_vm._v("订单")])]), _c('div', {
    staticClass: "navitem",
    on: {
      "click": _vm.getmember
    }
  }, [_c('div', [_c('svg', {
    staticClass: "icon",
    class: {
      "active": _vm.ismember
    },
    staticStyle: {
      "transform": "scale(1.2)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-geren"
    }
  })])]), _c('div', [_vm._v("个人中心")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-197b7d3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 111
// module chunks = 0